<template>
  <div class="col-sm-12 nopads">
    <div class="col-sm-12 editor-form nopads" @click.stop="">
      <h2 class="editor-header">{{ certificateTypeUpdate.id > 0 ? $t('certificate.edit_type') : $t('certificate.add_type')}}</h2>
      <div class="col-sm-12 form-data nopads">
        <span class="span-title pl-3">
          {{ $t('observations.name') }}
        </span>
        <div class="row">
          <div class="col-sm-6">
              <input
                  id="name"
                  v-model="certificateTypeUpdate.name"
                  type="text"
                  class="form-control form-control-sm"
              />
          </div>
          <div class="col-sm-6">
              <div class="form-check">
                  <input
                      id="is_expiring"
                      v-model="certificateTypeUpdate.is_expiring"
                      type="checkbox"
                      class="form-check-input"
                  />
                  <label class="form-check-label ms-2" for="is_expiring">
                      {{ $t('certificate.expiring') }}
                  </label>
              </div>
          </div>
        </div>
        <div class="col-sm-12 button-container">
          <button
            class="btn btn-secondary form-button"
            @click.stop="$emit('close')"
          >
              {{ $t('common.cancel') }}
          </button>
          <button
            class="btn btn-success form-button"
            :disabled="loading"
            @click.stop="submit"
          >
              {{ $t('common.save') }}
          </button>
        </div>
      </div>
    </div>
    <div
      v-if="loading"
      id="loader"
      class="spinner"
    />
  </div>
</template>

<script>
import {restApi} from '.././mixins/RestApiMixin'
import {inject} from "vue";

export default {
    name: 'CertificateTypeEditor',
    mixins: [restApi],
    props: {
        certificateType: {
            type: Object,
            default: null
        }
    },
    setup() {
        // Inject parents alerter
        const showAlert = inject('showAlert');
        return { showAlert };
    },
    data: function () {
        return {
            loading: false,
            certificateTypeUpdate: this.copyObj(this.certificateType)
        }
    },
    methods: {
        copyObj: function (obj) {
            return JSON.parse(JSON.stringify(obj))
        },
        submit: function () {
            if (this.certificateTypeUpdate.name.trim() === '') {
                this.showAlert(this.$t('inspectable_editor.invalid_name'))
                return
            }
            this.loading = true
            if (this.certificateTypeUpdate.id < 1) {
                var certificateType = this.copyObj(this.certificateTypeUpdate)
                certificateType.id = null
                this.restAdd(this.certificateTypeUrl, certificateType, this.success, this.fail)
            } else {
                this.restUpdate(this.certificateTypeUrl, this.certificateTypeUpdate, this.success, this.fail)
            }
        },
        success: function () {
            this.$emit('closeAndUpdate')
            this.loading = false
        },
        fail: function () {
            this.showAlert(this.$t('common.alert_update_failed'))
            this.loading = false
        }
    }
}
</script>
